module.exports = __webpack_public_path__ + "static/radio_logos-372401753e42f2ef3ed408f72ae24ee7.jpg";